module.exports = __webpack_public_path__ + "img/correios.2f0c7b94.jpeg";